import { render, staticRenderFns } from "./BioTemplates.vue?vue&type=template&id=425c800e&scoped=true&"
import script from "./BioTemplates.vue?vue&type=script&lang=js&"
export * from "./BioTemplates.vue?vue&type=script&lang=js&"
import style0 from "./BioTemplates.vue?vue&type=style&index=0&id=425c800e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425c800e",
  null
  
)

export default component.exports